"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getEnv = void 0;
const constants_1 = require("./constants");
const getEnv = (key) => {
    const value = process.env[key];
    if (!value) {
        throw new Error((0, constants_1.UNDEFINED_VARIABLE_MESSAGE)(key));
    }
    return value;
};
exports.getEnv = getEnv;
